<template>
  <div class="date-input" :class="{ 'date-input--focused': isFocused }">
    <svg class="date-input__icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
    <span v-if="value" class="date-input__value">{{ formattedDate }}</span>
    <span v-else class="date-input__placeholder">{{ placeholder }}</span>
    <input
      ref="input"
      type="date"
      :value="value"
      :required="required"
      class="date-input__native"
      @input="$emit('input', $event.target.value)"
      @click="openPicker"
      @focus="isFocused = true"
      @blur="isFocused = false"
    >
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  name: 'DateInput',
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Select date'
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isFocused: false
    }
  },
  methods: {
    openPicker (e) {
      if (e.target.showPicker) {
        try { e.target.showPicker() } catch (_) {}
      }
    }
  },
  computed: {
    formattedDate () {
      if (!this.value) return ''
      const d = dayjs(this.value)
      return d.isValid() ? d.format('D MMM YYYY') : this.value
    }
  }
}
</script>

<style scoped>
.date-input {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  border: 1px solid #d6d8e3;
  border-radius: 10px;
  padding: 10px 14px;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.15s;
}

.date-input:hover {
  border-color: #c2c5d0;
}

.date-input--focused {
  border-color: #7c5bea;
  box-shadow: 0 0 0 3px rgba(124, 91, 234, 0.1);
}

.date-input__icon {
  color: #7D7480;
  flex-shrink: 0;
}

.date-input__value {
  font-size: 14px;
  font-family: inherit;
  color: #131415;
  line-height: normal;
}

.date-input__placeholder {
  font-size: 14px;
  font-family: inherit;
  color: #b5b0b8;
  line-height: normal;
}

.date-input__native {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  border: none;
  padding: 0;
  margin: 0;
}
</style>
